import { useState } from 'react';
import { useT } from '../i18n/useT';
import { businessResources as brEn } from '../i18n/translations/en';
import { businessResources as brEs } from '../i18n/translations/es';
import './BusinessResources.css';

const BusinessResources = () => {
    const t = useT({ en: brEn, es: brEs });
    const [openCat, setOpenCat] = useState(null);
    const toggleCat = (id) => setOpenCat(prev => prev === id ? null : id);

    return (
        <section className="section" id="business-resources">
            <div className="container">
                <div className="section-header text-center">
                    <h2 className="section-title">{t.title}<span>{t.titleSpan}</span></h2>
                    <p className="section-subtitle">{t.subtitle}</p>
                </div>

                <div className="br-block" id="expansion">
                    <h3 className="br-block-title">{t.expansion.title}</h3>
                    <p>{t.expansion.body}</p>
                </div>
                <hr className="br-divider" />

                <div className="br-block" id="starting-business">
                    <h3 className="br-block-title">{t.startingBusiness.title}</h3>
                    <p className="br-sb-intro">{t.startingBusiness.intro}</p>
                    <div className="br-accordion">
                        {t.startingBusiness.categories.map(cat => {
                            const isOpen = openCat === cat.id;
                            return (
                                <div key={cat.id} className={`br-acc-panel${isOpen ? ' br-acc-panel--open' : ''}`}>
                                    <button className="br-acc-trigger" onClick={() => toggleCat(cat.id)}>
                                        <span>{cat.title}</span>
                                        <span className={`br-acc-caret${isOpen ? ' br-acc-caret--open' : ''}`}>▼</span>
                                    </button>
                                    {isOpen && (
                                        <ul className="br-acc-content">
                                            {cat.items.map((item, i) => (
                                                <li key={i} className="br-sb-item">
                                                    <strong>{item.name}</strong>
                                                    <span className="br-sb-desc"> — {item.desc}</span>
                                                    {item.links.length > 0 && (
                                                        <span className="br-sb-links">
                                                            {item.links.map((lnk, j) => (
                                                                <a key={j} href={lnk.href} target="_blank" rel="noreferrer" className="br-sb-link">
                                                                    {lnk.label} ↗
                                                                </a>
                                                            ))}
                                                        </span>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <hr className="br-divider" />

                <div className="br-block" id="incentives">
                    <h3 className="br-block-title">{t.incentives.title}</h3>
                    <div className="br-incentives-grid">
                        {t.incentives.items.map((inc, i) => (
                            <div key={i} className="br-incentive-card">
                                <span className="br-incentive-num">{String(i + 1).padStart(2, '0')}</span>
                                <h4>{inc.name}</h4>
                                <p>{inc.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
                <hr className="br-divider" />

                <div className="br-block" id="tax-rates">
                    <h3 className="br-block-title">{t.taxRates.title} <span className="br-asof">({t.taxRates.asOf})</span></h3>
                    <div className="br-tax-cols">
                        <div>
                            <h4 className="br-tax-subtitle">{t.taxRates.propSubtitle}</h4>
                            <table className="br-tax-table">
                                <tbody>
                                    {t.taxRates.propRates.map((r, i) => (
                                        <tr key={i}><td>{r.label}</td><td className="br-tax-rate">{r.rate}</td></tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div>
                            <h4 className="br-tax-subtitle">{t.taxRates.salesSubtitle}</h4>
                            <table className="br-tax-table">
                                <tbody>
                                    {t.taxRates.salesRates.map((r, i) => (
                                        <tr key={i} className={r.bold ? 'br-tax-total' : ''}>
                                            <td>{r.label}</td><td className="br-tax-rate">{r.rate}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <hr className="br-divider" />

                <div className="br-block" id="research">
                    <h3 className="br-block-title">{t.research.title}</h3>
                    <div className="br-map-links">
                        {t.research.maps.map((m, i) => (
                            <a key={i} href="#research" className="br-map-link">
                                <span className="br-map-icon">🗺</span>{m}
                            </a>
                        ))}
                    </div>
                </div>
                <hr className="br-divider" />

                <div className="br-block" id="partners">
                    <h3 className="br-block-title">{t.partners.title}</h3>
                    <div className="br-partners-list">
                        {t.partners.items.map((p, i) => (
                            <div key={i} className="br-partner-item">
                                <span className="br-check">✓</span> {p}
                            </div>
                        ))}
                    </div>
                </div>
                <hr className="br-divider" />

                <div className="br-block" id="job-research">
                    <h3 className="br-block-title">{t.jobResearch.title}</h3>
                    <div className="br-job-links">
                        {t.jobResearch.links.map((j, i) => (
                            <a key={i} href={j.href} target="_blank" rel="noreferrer" className="btn btn-primary">
                                {j.name} →
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BusinessResources;
